
// ./components/shopsubbanner.jsx
import React from "react";
import "./index.css"; // Import your CSS file here

const Shopsubbanner = ({ image_url, title }) => {
  return (
    <section className="banner-image-sachin-banner sub_banner_derby_india position-relative">
      <div className="banner-image-container">
        <img src={image_url || "/placeholder.svg"} alt="Banner" className="banner-image-sachin" />
      </div>
      <div className="container position-relative">
        <div className="row">
          <div className="col-12">
            <div className="banner-sachin-content text-center" data-aos="fade-up">
              {title && <h3>{title}</h3>} {/* Render only if title is provided */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Shopsubbanner;

